import React from 'react';
import { VerificationEntry } from '../../types';
import VerificationRow from './VerificationRow';

interface VerificationTableProps {
  entries: VerificationEntry[];
  onViewDetails: (entry: VerificationEntry) => void;
  formatDate: (date: Date) => string;
}

const VerificationTable: React.FC<VerificationTableProps> = ({
	entries,
	onViewDetails,
	formatDate,
}) => {
	return (
		<div className="bg-white rounded-xl shadow-sm overflow-x-auto">
			<table className="min-w-full text-sm">
				<thead className="bg-gray-50">
					<tr>
						<th className="px-3 py-2 text-left font-medium text-gray-500 uppercase">
              Ghana Card ID
						</th>
						<th className="px-3 py-2 text-left font-medium text-gray-500 uppercase">Name</th>
						<th className="px-3 py-2 text-center font-medium text-gray-500 uppercase">
              Status
						</th>
						<th className="px-3 py-2 text-left font-medium text-gray-500 uppercase">Date</th>
						<th className="px-3 py-2 text-left font-medium text-gray-500 uppercase">Action</th>
					</tr>
				</thead>
				<tbody className="divide-y divide-gray-200">
					{entries.map(entry => (
						<VerificationRow 
							key={entry.id}
							entry={entry}
							onViewDetails={onViewDetails}
							formatDate={formatDate}
						/>
					))}
				</tbody>
			</table>
		</div>
	);
};

export default VerificationTable;
